import React, { type FC, type PropsWithChildren } from 'react';

type TwitterProps = {
  /** The color of the icon. */
  color?: string;
};

const Twitter: FC<PropsWithChildren<TwitterProps>> = ({ color = 'currentcolor' }) => (
  <svg
    id="Layer_1"
    version="1.1"
    viewBox="0 0 300 261.4"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    y="0px"
  >
    <g>
      <path
        d="M281.8,47.2c-9.7,4.3-20.1,7.2-31.1,8.5c11.2-6.7,19.7-17.3,23.8-29.9c-10.4,6.2-22,10.7-34.3,13.1 c-9.8-10.5-23.9-17.1-39.5-17.1c-34.9,0-60.6,32.6-52.7,66.4C103.1,86,63.3,64.4,36.6,31.7C22.4,56,29.2,87.8,53.3,103.9 c-8.9-0.3-17.2-2.7-24.5-6.8c-0.6,25,17.4,48.5,43.4,53.7c-7.6,2.1-15.9,2.5-24.4,0.9c6.9,21.5,26.8,37.1,50.5,37.5 c-22.7,17.8-51.4,25.8-80,22.4c23.9,15.3,52.4,24.3,82.9,24.3c100.4,0,157.1-84.8,153.7-160.8C265.4,67.5,274.5,58,281.8,47.2z"
        fill={color}
      />
    </g>
  </svg>
);

export default Twitter;
